import React, { useState } from "react";

// Dynamically import all images
const importAll = (r) =>
  r.keys().map((key) => {
    const module = r(key);
    const src = module.default || module;
    return {
      src,
      name: key.replace("./", "").split(".")[0],
    };
  });

// Import images
const images = importAll(
  require.context(
    "../../../assets/Ourmilestones/winningmoments",
    false,
    /\.(png|jpe?g|webp)$/
  )
);

const WinningMoments = () => {
  const [selectedImg, setSelectedImg] = useState(null);

  const formatTitle = (name) => {
    const parts = name.split(" - ");
    if (parts.length >= 4) {
      const caseNumber = `${parts[0]} - ${parts[1]} - ${parts[2]}`;
      const title = parts.slice(3).join(" - ");
      return { caseNumber, title };
    }
    // fallback for short names
    return { caseNumber: name, title: "" };
  };

  return (
    <div className="p-6">
      <h2 className="text-3xl font-bold text-gray-800 mb-4 text-center">
        🏆 Winning Moments – Justice Delivered
      </h2>

      <p className="text-gray-600 text-center mb-10 max-w-2xl mx-auto">
        These case files represent our clients’ victories against unethical business practices.
        Tap any card below to open the authenticated document.
      </p>

      {/* Gallery Grid */}
      <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-4">
        {images.map((img, index) => {
          const overlayColor =
            index % 2 === 0 ? "bg-yellow-600/80" : "bg-orange-600/80"; // alternating tint
          const { caseNumber, title } = formatTitle(img.name);

          return (
            <div
              key={index}
              onClick={() => setSelectedImg(img.src)}
              className="relative rounded-md shadow-md cursor-pointer h-48 overflow-hidden hover:shadow-lg transition-all"
            >
              {/* Background image */}
              <img
                src={img.src}
                alt={img.name}
                className="absolute inset-0 w-full h-full object-cover"
              />

              {/* Blue overlay */}
              <div
                className={`absolute inset-0 ${overlayColor} transition-opacity duration-300 hover:opacity-40`}
              ></div>

           {/* Text & icon */}
<div className="absolute bottom-0 left-0 w-full z-10 text-white text-center px-2 py-3">
  <p className="text-[24px] drop-shadow-lg mb-1">🏆</p>
  <p className="text-[18px] font-semibold drop-shadow-md">
    Case Number : {caseNumber}
  </p>
  {title && (
    <p className="text-[18px] italic font-medium drop-shadow-md mb-1">
      {title}
    </p>
  )}
  <p className="text-[12px] bg-black inline-block px-2 py-[2px] rounded-md mt-1">
    (Click here to learn more)
  </p>
</div>

            </div>
          );
        })}
      </div>

      {/* Modal */}
      {selectedImg && (
        <div
          className="fixed inset-0 bg-black bg-opacity-80 flex items-center justify-center z-50 cursor-pointer"
          onClick={() => setSelectedImg(null)}
        >
          <img
            src={selectedImg}
            alt="Full View"
            className="max-w-full max-h-full rounded-xl shadow-xl"
          />
        </div>
      )}
    </div>
  );
};

export default WinningMoments;
